/* eslint-disable import/prefer-default-export */
export const ACCOUNT_ROLES = {
  ADMIN: 4,
  COLLABORATOR: 2,
}
export const ACCOUNT_MODULE_PERMISSION = {
  VIEW: 'GET',
  EDIT: 'PUT',
  NONE: 'NONE',
  ACCESS: 'ACCESS',
}
export const options = [{
  value: ACCOUNT_MODULE_PERMISSION.EDIT,
  label: 'Edit'
}, {
  value: ACCOUNT_MODULE_PERMISSION.VIEW,
  label: 'View Only'
}]
export const modules = [
  {
    name: 'productManagement',
    label: 'Product Management',
    options
  },
  {
    name: 'supplierManagement',
    label: 'Supplier  Management',
    options
  },
  {
    name: 'productTesting',
    label: 'Product Testing',
    options
  },
  {
    name: 'inspection',
    label: 'QC Inspection',
    options,
    subs: [{
      name: 'qcInspection',
      label: 'IQC',
      options,
    }]
  },
  {
    name: 'factoryAudit',
    label: 'Factory Audit',
    options
  },
  {
    name: 'poManagement',
    label: 'PO',
    options
  },
  {
    name: 'testPlanManagement',
    label: 'Test Plan',
    options
  },
]
const moduleKeys = [];
modules.forEach(mo => {
  moduleKeys.push(mo.name);
  if (mo.subs) {
    mo.subs.forEach(sub => {
      moduleKeys.push(sub.name);
    })
  }
})
export { moduleKeys };